import { CartAddEvent } from '@theme/events';
const pfS=(()=>{let map=null;return (text,vars)=>{if(!map){map={};const box=document.createElement('textarea');document.querySelectorAll('script[data-pf-strings]').forEach(el=>{try{const o=JSON.parse(el.textContent);for(const k in o){box.innerHTML=o[k];const v=box.value;if(v&&!/^translation missing/i.test(v))map[k]=v;}}catch(e){}});}let out=map[text]??text;if(vars)for(const k in vars)out=out.split('{'+k+'}').join(String(vars[k]));return out;};})();

/**
 * Buy area for the heated house slippers (sections/pf-slipper-main.liquid):
 * gallery, foot-length selection, add to cart with the cart drawer, sticky bar.
 */
class PfSlipper extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });
    this.track = this.querySelector('[data-track]');
    this.slides = [...this.querySelectorAll('.jnh-slide')];
    this.thumbs = [...this.querySelectorAll('[data-thumb]')];
    this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
    this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.go(Number(thumb.dataset.thumb))));
    this.index = 0;
    this.track?.addEventListener('scroll', () => {
      const left = this.track.scrollLeft;
      let best = 0;
      this.slides.forEach((slide, i) => {
        if (Math.abs(slide.offsetLeft - this.track.offsetLeft - left) < Math.abs(this.slides[best].offsetLeft - this.track.offsetLeft - left)) best = i;
      });
      this.setCurrent(best);
    }, { passive: true });
    this.querySelectorAll('[data-option] input').forEach((input) => input.addEventListener('change', () => this.update()));
    this.querySelector('[data-size-link]')?.addEventListener('click', () => {
      const details = this.querySelector(this.querySelector('[data-size-link]').getAttribute('href'));
      if (details) details.open = true;
    });
    this.querySelector('[data-form]').addEventListener('submit', (event) => this.add(event));
    const sticky = this.querySelector('[data-sticky]');
    this.io = new IntersectionObserver(([entry]) => sticky?.classList.toggle('is-hidden', entry.isIntersecting || entry.boundingClientRect.bottom > 0));
    this.io.observe(this.querySelector('[data-atc]'));
  }

  disconnectedCallback() {
    this.io?.disconnect();
  }

  setCurrent(i) {
    this.index = i;
    this.thumbs.forEach((thumb, n) => thumb.setAttribute('aria-current', n === i ? 'true' : 'false'));
  }

  go(i) {
    if (!this.slides.length) return;
    const next = (i + this.slides.length) % this.slides.length;
    this.track.scrollTo({ left: this.slides[next].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    this.setCurrent(next);
  }

  current() {
    const picked = [...this.querySelectorAll('[data-option]')].map((field) => field.querySelector('input:checked')?.value);
    return this.variants.find((variant) => variant.options.every((value, i) => value === picked[i]));
  }

  update() {
    const variant = this.current();
    const atc = this.querySelector('[data-atc]');
    this.querySelector('[data-id]').value = variant?.id || '';
    atc.disabled = !variant?.available;
    atc.textContent = variant?.available ? pfS('In den Warenkorb') : pfS('Derzeit nicht verfügbar');
    const dyn = this.querySelector('[data-dyn]');
    if (dyn) dyn.hidden = !variant?.available;
    if (!variant) return;
    const onSale = variant.compare_at_price > variant.price;
    this.querySelector('[data-price]').textContent = this.money.format(variant.price / 100);
    this.dispatchEvent(new CustomEvent('pf:variant', { detail: variant }));
    const compare = this.querySelector('[data-compare]');
    compare.hidden = !onSale;
    compare.textContent = this.money.format((variant.compare_at_price || variant.price) / 100);
    const saving = this.querySelector('[data-saving]');
    if (saving) {
      saving.hidden = !onSale;
      saving.textContent = pfS('Sie sparen {amount}', { amount: this.money.format(((variant.compare_at_price || variant.price) - variant.price) / 100) });
    }
    const sticky = this.querySelector('[data-sticky-price]');
    if (sticky) sticky.textContent = this.money.format(variant.price / 100);
    const stickyCompare = this.querySelector('[data-sticky-compare]');
    if (stickyCompare) stickyCompare.textContent = onSale ? this.money.format(variant.compare_at_price / 100) : '';
    const stickyBadge = this.querySelector('[data-sticky-badge]');
    if (stickyBadge) {
      stickyBadge.hidden = !onSale;
      stickyBadge.textContent = `−${Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100)}\u00a0%`;
    }
    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url);
  }

  async add(event) {
    event.preventDefault();
    const variant = this.current();
    if (!variant || this.adding) return;
    this.adding = true;
    const button = this.querySelector('[data-atc]');
    const error = this.querySelector('[data-error]');
    button.disabled = true;
    error.hidden = true;
    const drawer = document.querySelector('cart-drawer-component');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean))];
      drawer?.open?.();
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: Math.max(1, parseInt(this.querySelector('form [name="quantity"]')?.value, 10) || 1) }], ...(sectionIds.length ? { sections: sectionIds, sections_url: location.pathname } : {}) }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || pfS('Das Hinzufügen war nicht möglich. Bitte versuchen Sie es erneut.'));
      const cart = await fetch(`${root}cart.js`).then((r) => r.json());
      this.dispatchEvent(new CartAddEvent(cart, this.id, { source: 'pf-slipper', productId: this.dataset.productId, itemCount: 1, sections: data.sections }));
      if (!drawer) location.href = `${root}cart`;
    } catch (e) {
      error.textContent = e.message;
      error.hidden = false;
    } finally {
      this.adding = false;
      button.disabled = !variant.available;
    }
  }
}

if (!customElements.get('pf-slipper')) customElements.define('pf-slipper', PfSlipper);
